import { createSelector } from 'reselect';
import { isAuthenticated } from '../user/selectors';

export const isDetailsLoaded = state => state.getIn(['account', 'detailsLoaded']);
export const isDetailsPending = state => state.getIn(['account', 'detailsPending']);
export const getMobileNumber = state => state.getIn(['account', 'phoneNumber']);
export const getCardNumber = state => state.getIn(['account', 'cardNumber']);
export const isOmniLinked = state => state.getIn(['account', 'omniLinked']);
export const hasOmniPIN = state => state.getIn(['account', 'omniHasPIN']);
export const getConsents = state => state.getIn(['account', 'consents']);
export const reConsent = state => state.getIn(['account', 'reConsent']);
export const getNumberOfSavedSlips = state => state.getIn(['account', 'numberOfSavedSlips']);

export const isBalancePending = (state) => state.getIn(['account', 'balancePending']);
export const getTotalBalance = (state) => state.getIn(['account', 'totalBalance']);
export const getAvailableBalance = (state) => state.getIn(['account', 'availableBalance']);

export const mustLoadSettings = createSelector(
  isAuthenticated,
  isDetailsLoaded,
  isDetailsPending,
  (authenticated, loaded, pending) => authenticated && !loaded && !pending
);

export const canLinkAccounts = createSelector(
  isAuthenticated,
  isDetailsLoaded,
  isOmniLinked,
  (authenticated, loaded, linked) => authenticated && loaded && !linked
);

export const isAuthenticatedAsOmni = createSelector(
  isAuthenticated,
  isDetailsLoaded,
  isOmniLinked,
  (authenticated, loaded, linked) => authenticated && loaded && linked
);

export const canSetOmniPIN = createSelector(
  isAuthenticatedAsOmni,
  hasOmniPIN,
  (omni, hasPIN) => omni && !hasPIN
);

export const canChangeOmniPIN = createSelector(
  isAuthenticatedAsOmni,
  hasOmniPIN,
  (omni, hasPIN) => omni && hasPIN
);

export const hasSavedSlips = createSelector(
  getNumberOfSavedSlips,
  count => (
    isNaN(count) ? undefined : !!count
  )
);
